import React from 'react';
import './components.css';

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-inner">
        <span className="hero-kicker">
          Family-Owned<span className="dot" />Utah<span className="dot" />Est. 2025
        </span>

        <h1>
          A quiet corner<br />
          for <em>curious readers.</em>
        </h1>

        <p className="hero-tagline">
          Over 35,000 books on hand-built shelves — with room to sit, sip, and stay awhile.
        </p>

        <div className="hero-actions">
          <a href="#calendar" className="btn btn-primary">See what's on</a>
          <a href="#trading" className="btn btn-ghost">Buy · Sell · Trade</a>
        </div>
      </div>

      <div className="hero-meta" aria-hidden="true">
        <span>Vol. 01 — The Happy Book Stack</span>
        <span>A Utah Reading Room</span>
      </div>
    </section>
  );
}

export default Hero;
